import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
export var CounterStyle;
(function (CounterStyle) {
    CounterStyle["Info"] = "Info";
    CounterStyle["Warning"] = "Warning";
})(CounterStyle || (CounterStyle = {}));
const b = bemClassBuilder('v-counter');
export const Counter = observer(props => {
    const { denominator, numerator, label, style } = props;
    return denominator === 0 && numerator === 0 ? null : (_jsx("div", Object.assign({ className: b.block({ style: style }) }, { children: _jsxs("div", Object.assign({ className: b.element('wrapper') }, { children: [_jsxs("span", Object.assign({ className: b.element('number') }, { children: [numerator, "/", denominator] })), _jsx("span", Object.assign({ className: b.element('label') }, { children: label }))] })) })));
});
Counter.displayName = 'Counter';
